const styles = () => ({
  columnImage: {
    alignItems: 'center',
    display: 'flex',
  },

  columnImageText: {
    alignSelf: 'center',
    flex: '1 1 auto',
    margin: '0 0 0 15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export default styles;
